import React, { useState } from 'react';
//import AppService/*, { Utilities }*/ from 's2s-app-service';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import ContactList from '../components/contactList';
import NumberSelection from '../components/numberSelectionModal';
import Modal from 'react-modal';
import { getIntlText } from '../js/utilities';
import styled from 'styled-components';
import { } from '../js/store';
import { phoneNumberValidation } from '../js/utilities';
import { track } from 's2s-app-service';
import useCallInfo from '../hooks/callInfo';

//import useSettings from '../hooks/settings';

const composedHoc = compose(injectIntl);
const ComposedContactList = composedHoc(ContactList);
const ComposedNumberSelection = composedHoc(NumberSelection);

const reactModalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(34, 138, 230, 0.72)',
    zIndex: '1000'
  },
  content: {
    alignItems: 'center',
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    border: 'none',
    background: 'transparent',
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};

const ContactsContainer = styled.div`
  //height : calc(100vh - 48px);
  //width : 272px;
`;

const StyledNumberSelection = styled(ComposedNumberSelection)`
  min-width: 230px;  // combined with border (2px left and right) the full minWidth of modal is 234px. This is consistent with modal in ContactDetails. - KCN
  max-width: 230px;  // combined with border (2px left and right) the full maxWidth of modal is 234px. This is consistent with modal in ContactDetails. - KCN
`;

const ContactsRoute = injectIntl(({ history, match, intl, status }) => {
  Modal.setAppElement('#root'); // some accessibility stuff react-modal wants defined or else throws a warning. http://reactcommunity.org/react-modal/accessibility/#app-element - KCN 03/13/19 

  const [modalOpen, setModalVisibility] = useState(false);
  const [contactName, setContactName] = useState("");
  const [contactPhones, setContactPhones] = useState([]);
  const [callInfo, { makeCall, holdCall }] = useCallInfo();

  //const [settings] = useSettings(); // TODO used for makeCall arguments

  const callContact = (aPhoneNumber) => {
    // if there is an active call, put it on hold
    console.log('');

    if (callInfo.activeCallId.length > 0 && typeof callInfo.inprogressCalls[callInfo.activeCallId] !== "undefined" && callInfo.inprogressCalls[callInfo.activeCallId].isHeld === false) {
      holdCall(callInfo.activeCallId, intl);
    }

    makeCall(aPhoneNumber);
    history.push('/callprogress');
  };

  const handleClickContact = (data) => {
    console.log('clicked contact!', data);
    history.push(`/contacts/${data.uuid}`);
  };

  const handleActionClick = (contactData) => {
    track("contact_action", "clicked");
    //console.log('Contact Item New Call clicked.', contactData);
    // determine which number to call.
    if (contactData && contactData.name && contactData.name.first && contactData.name.last) {
      setContactName(`${contactData.name.first} ${contactData.name.last}`);
    } else {
      if (contactData.name.first) {
        setContactName(`${contactData.name.first}`);
      }

      if (contactData.name.last) {
        setContactName(`${contactData.name.last}`);
      }
    }

    const phoneNumber = getNumberToDial(contactData);
    // call the contact
    if (phoneNumber !== undefined) {
      callContact(phoneNumber);
    }
  };

  const getNumberToDial = (contactData) => {
    let retValue = undefined;
    // if no phone numbers, do nothing, if only one OR one is preferred, return that numbers
    // if multiple, set state to show modal and allow selection of numbers
    if (contactData.phone_numbers) {
      switch (contactData.phone_numbers.length) {
        case 0:
          // do nothing since no numbers...
          break;
        case 1:
          retValue = contactData.phone_numbers[0].number;
          break;
        default:
          // Show Modal for selecting number to message
          setModalVisibility(true);
          setContactPhones([].concat(contactData.phone_numbers));
      }
    }
    // Return the number to message
    return retValue;
  };

  const handleModalNumberSelected = (numberObj) => {
    if (numberObj && numberObj.number) {
      //console.log("dispatch doMakeCall ");
      callContact(numberObj.number);
    }
    // close the modal now....
    setModalVisibility(false);
  };

  // Reroutes to new contact when user clicks add contact
  const handleAddClick = () => {
    track("new_contact", "clicked");
    history.push("/contacts/new/edit");
  };

  const handleImportAddClick = (actionType) => {
    switch (actionType) {
      case 'add':
        handleAddClick();
        break;
      case 'import':
        history.push('/settings/contacts');
        break;
      default:
        handleAddClick();
    }
  };

  console.log('CONTACT PHONE HOOK value', contactPhones);
  return (
    <ContactsContainer className='ContactsContainer' >
      <Modal
        isOpen={modalOpen}
        style={reactModalStyle}
        contentLabel="Contact Number Selection"
        shouldCloseOnOverlayClick={false}
      >
        <StyledNumberSelection
          className="StyledNumberSelection"
          cbCancelNumberSelection={() => { setModalVisibility(false); }}
          cbHandleNumberSelected={handleModalNumberSelected}
          cbPhoneNumberValidation={phoneNumberValidation}
          contactName={contactName}
          contactNumberList={contactPhones}
          selectMessageText={getIntlText(intl, 'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL', 'Select the number to call')}
        />
      </Modal>
      <ComposedContactList
        cbAddOnClick={handleAddClick}
        cbContactOnClick={handleClickContact}
        cbContactActionOnClick={handleActionClick}
        cbImportAddClick={handleImportAddClick}
        contactName={contactName}
        contactPhones={contactPhones}
      />
    </ContactsContainer>
  );
});

export default ContactsRoute;
